// Custom toast utility that bypasses modal z-index issues
let toastCounter = 0;

const createToastElement = (message, type = 'success') => {
    const toastId = `custom-toast-${++toastCounter}`;
    
    const toast = document.createElement('div');
    toast.id = toastId;
    toast.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 2147483647;
        background: ${type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#007bff'};
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 14px;
        font-weight: 500;
        box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        max-width: 350px;
        word-wrap: break-word;
        cursor: pointer;
        transition: all 0.3s ease;
        transform: translateX(400px);
        opacity: 0;
        pointer-events: auto;
    `;
    
    toast.textContent = message;
    
    // Click to dismiss
    toast.addEventListener('click', () => {
        removeToast(toastId);
    });
    
    return toast;
};

const removeToast = (toastId) => {
    const toast = document.getElementById(toastId);
    if (toast) {
        toast.style.transform = 'translateX(400px)';
        toast.style.opacity = '0';
        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        }, 300);
    }
};

const showToast = (message, type = 'success', duration = 5000) => {
    const toast = createToastElement(message, type);
    document.body.appendChild(toast);
    
    // Animate in
    setTimeout(() => {
        toast.style.transform = 'translateX(0)';
        toast.style.opacity = '1';
    }, 10);
    
    // Auto remove
    setTimeout(() => {
        removeToast(toast.id);
    }, duration);
    
    return toast.id;
};

export const customToast = {
    success: (message, duration) => showToast(message, 'success', duration),
    error: (message, duration) => showToast(message, 'error', duration),
    info: (message, duration) => showToast(message, 'info', duration)
}; 